import React, { useCallback, useEffect, useMemo } from 'react';

import { useAppDispatch, useAppSelector } from '../../../hooks/react-redux';
import { useFetchStarted } from '../../../hooks/useFetchStarted';
import { fetchAllDropdownListsStarted } from '../dropdown-lists/store';
import styles from './Calculator.module.scss';
import { CalculatorManagerSelect } from './CalculatorManagerSelect';
import { CalculatorPrompt } from './prompts/CalculatorPrompt';
import { CalculatorManagerPage, fetchCalculatorPromptsStarted, getCalculatorManagerPage, setCalculatorManagerPage } from './store';
import { CalculatorManager } from './manager/CalculatorManager';
import { fetchAllClientsStarted } from '../clients/store';

export const AdminCalculator: React.FC = () => {
    const attestationPage = useAppSelector(getCalculatorManagerPage);
    const dispatch = useAppDispatch();
    const resetPageView = useCallback(() => dispatch(setCalculatorManagerPage(CalculatorManagerPage.SELECT)), [dispatch]);
    useFetchStarted([fetchCalculatorPromptsStarted(), fetchAllDropdownListsStarted(), fetchAllClientsStarted()]);

    useEffect(() => () => {
        resetPageView();
    }, [resetPageView]);

    const pageContent = useMemo(() => {
        switch (attestationPage) {
            case CalculatorManagerPage.SELECT:
            default:
                return <CalculatorManagerSelect />;
            case CalculatorManagerPage.PROMPTS:
                return <CalculatorPrompt />;
            case CalculatorManagerPage.MANAGER:
                return <CalculatorManager />;
        }
    }, [attestationPage]);

    return (
        <div className={styles.adminCalculatorWrapper} data-testid='admin-calculator-manager-wrapper'>
            {pageContent}
        </div>
    );
};
